/**
 * @generated SignedSource<<9ee3f9a57de5317e4fc51df028f0fd66>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moreDropdown_AtlassianHubAppShell$data = {
  readonly customPages: ReadonlyArray<{
    readonly id: string;
    readonly name: {
      readonly default: string;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "moreDropdown_AtlassianHubAppShell";
};
export type moreDropdown_AtlassianHubAppShell$key = {
  readonly " $data"?: moreDropdown_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"moreDropdown_AtlassianHubAppShell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "sendDraftPages"
    }
  ],
  "kind": "Fragment",
  "name": "moreDropdown_AtlassianHubAppShell",
  "selections": [
    {
      "alias": "customPages",
      "args": [
        {
          "fields": [
            {
              "kind": "Literal",
              "name": "ids",
              "value": []
            },
            {
              "kind": "Variable",
              "name": "sendDraftPages",
              "variableName": "sendDraftPages"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "CUSTOM"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "HelpCenterPage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "HelpCenterPageName",
          "kind": "LinkedField",
          "name": "name",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "default"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "9e1be47b19d0730d07696a168a8bebd8";

export default node;
